import React from 'react';
import ProductTile from './ProductTile';
import PropTypes from 'prop-types';
import WithClickTracking from '../../components/WithClickTracking';

const ProductTileWithClickTracking = WithClickTracking(ProductTile);

const ProductTileContainer = ({ products, onResultClick }) =>
    <div className="product-list">
        {products.map((product, i) => {
            return (
                <div key={i} className="row">
                    <div className="col-12 result-tile-borders">
                        <ProductTileWithClickTracking 
                            name={product.Name}
                            url={product.Url}
                            image={product.Image}
                            HitId={product.HitId}
                            onResultClick={onResultClick}
                            description={product.Description} 
                            formats={product.Formats.join(', ')}
                            languages={product.Languages.join(', ')}
                        />
                    </div>
                </div>
            );
        })}
    </div>;

ProductTileContainer.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        Formats: PropTypes.arrayOf(PropTypes.string),
        Languages: PropTypes.arrayOf(PropTypes.string)
    }))
};

export default ProductTileContainer;